import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiFetchDonationHistory = (funcToDispatch, error) => {
  $.ajax({
    type: "GET",
    url: "/api/donationHistory",
    dataType: "JSON",
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "fetchDonationHistory"),
  })
}

export const apiProcessDonation = (payload, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/charge",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: payload,
    success,
    error: wrapError(error, "apiProcessDonation"),
  })
}

export const apiProcessDonationSession = (payload, _success, error, receiveDonationSessionId) => {
  $.ajax({
    type: "POST",
    url: "/api/session",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: payload,
    success: wrapSuccess(receiveDonationSessionId),
    error: wrapError(error, "apiProcessDonation"),
  })
}

export const apiCancelSubscription = (subscriptionId, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/cancelSubscription",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: subscriptionId,
    success,
    error,
  })
}
